import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const SearchPage = lazy(() => import('../pages/search/page'));
const MessagesPage = lazy(() => import('../pages/messages/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/kayit',
    element: <RegisterPage />,
  },
  {
    path: '/profil',
    element: <ProfilePage />,
  },
  {
    path: '/mesajlar',
    element: <MessagesPage />,
  },
  {
    path: '/arama',
    element: <SearchPage />,
  },
  {
    path: '/ayarlar',
    element: <SettingsPage />,
  },
  {
    path: '/yonetici',
    element: <AdminPage />,
  },
  {
    path: '/urun/:id',
    lazy: async () => {
      const { default: Component } = await import('../pages/product-detail/page');
      return { Component };
    },
  },
  {
    path: '/sepet',
    lazy: async () => {
      const { default: Component } = await import('../pages/cart/page');
      return { Component };
    },
  },
  {
    path: '/odeme',
    lazy: async () => {
      const { default: Component } = await import('../pages/checkout/page');
      return { Component };
    },
  },
  {
    path: '/siparis-basarili/:id?',
    lazy: async () => {
      const { default: Component } = await import('../pages/order-success/page');
      return { Component };
    },
  },
  {
    path: '/siparislerim',
    lazy: async () => {
      const { default: Component } = await import('../pages/orders/page');
      return { Component };
    },
  },
  {
    path: '/favorilerim',
    lazy: async () => {
      const { default: Component } = await import('../pages/favorites/page');
      return { Component };
    },
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;